enum StockError {
    Null,
    CheckoutValueIsNotAvailable,
    CheckoutValueExceedEstimatedValue,
    ValueIsNotRounded,
    StockValueIsNotAvailable
}

export default StockError;



// WEBPACK FOOTER //
// ./src/domain/orders/validators/error.ts